import '../App.css';

function Home() {
  return (
    <div className="home-container" style={{ background: 'linear-gradient(120deg, #e0e7ff 0%, #f8fafc 100%)', minHeight: '100vh', paddingBottom: 40 }}>
      <div className="section-card" style={{ boxShadow: '0 8px 32px rgba(37,99,235,0.08)', borderRadius: 24, background: '#fff', margin: '32px auto', maxWidth: 1200, padding: '32px 0', animation: 'fadeIn 1.2s' }}>
        {/* WHO WE ARE */}
        <div className="section" style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', marginBottom: 32 }}>
          <div className="text-side" style={{ flex: 1, minWidth: 320, padding: '0 32px', animation: 'slideInLeft 1s' }}>
            <h1 style={{ fontSize: 38, color: '#2563eb', marginBottom: 16, fontWeight: 800, letterSpacing: '-1px' }}>Who We Are</h1>
            <p style={{ fontSize: 18, color: '#222', marginBottom: 12 }}>
              Ventrai is a growing community built by a 12-year-old developer who believes mentorship should be simple, friendly, and available to everyone.  
              We’re here to make it easy for students to connect with mentors who’ve been where they are, to ask questions, get advice, and grow together.
            </p>
            <p style={{ fontSize: 18, color: '#222' }}>
              Whether you’re exploring your first coding project, preparing for high school, or finding your way through life’s challenges, 
              Ventrai helps you find someone who’s already been there, and wants to help you get further.
            </p>
          </div>
          <div className="image-side" style={{ flex: 1, minWidth: 320, display: 'flex', justifyContent: 'center', alignItems: 'center', animation: 'slideInRight 1s' }}>
            <picture>
              <source media="(max-width: 600px)" srcSet="https://raw.githubusercontent.com/DenzelDCB/k9g-EzD-WGg-8Pnc-x2g2-MWY-AG4UVn-y-7e-z-ep/Private-Images/phonehome.png" />
              <img
                src="https://raw.githubusercontent.com/DenzelDCB/k9g-EzD-WGg-8Pnc-x2g2-MWY-AG4UVn-y-7e-z-ep/Private-Images/home.png"
                alt="Mentoring graphic"
                className="responsive-image"
                style={{ borderRadius: 18, boxShadow: '0 4px 24px rgba(37,99,235,0.12)', transition: 'transform 0.3s', cursor: 'pointer' }}
                onMouseOver={e => e.currentTarget.style.transform = 'scale(1.04)'}
                onMouseOut={e => e.currentTarget.style.transform = 'scale(1)'}
              />
            </picture>
          </div>
        </div>

        {/* WHY CHOOSE OUR MENTORING */}
        <div className="section" style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', marginBottom: 32 }}>
          <div className="image-side" style={{ flex: 1, minWidth: 320, display: 'flex', justifyContent: 'center', alignItems: 'center', animation: 'slideInLeft 1.2s' }}>
            <img
              src="https://raw.githubusercontent.com/DenzelDCB/k9g-EzD-WGg-8Pnc-x2g2-MWY-AG4UVn-y-7e-z-ep/Private-Images/processes.png"
              alt="Mentoring process illustration"
              className="responsive-image"
              style={{ borderRadius: 18, boxShadow: '0 4px 24px rgba(52,152,219,0.12)', transition: 'transform 0.3s', cursor: 'pointer' }}
              onMouseOver={e => e.currentTarget.style.transform = 'scale(1.04)'}
              onMouseOut={e => e.currentTarget.style.transform = 'scale(1)'}
            />
          </div>
          <div className="text-side" style={{ flex: 1, minWidth: 320, padding: '0 32px', animation: 'slideInRight 1.2s' }}>
            <h1 style={{ fontSize: 36, color: '#2563eb', marginBottom: 16, fontWeight: 800, letterSpacing: '-1px' }}>Why Choose Our <br /> Mentoring?</h1>
            <p style={{ fontSize: 18, color: '#222', marginBottom: 12 }}>
              If you’re in middle or high school, you’ll find mentors who have already gone through what you’re facing now, from exams to personal growth.  
              These mentors don’t just offer advice; they share their real experiences and help you move forward confidently.
            </p>
            <p style={{ fontSize: 18, color: '#222' }}>
              At Ventrai, mentorship is about understanding and guidance, not grades or pressure.  
              We focus on creating an atmosphere of encouragement, curiosity, and mutual respect.
            </p>
          </div>
        </div>

        {/* KEY FEATURES */}
        <div className="section" style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', marginBottom: 32 }}>
          <div className="text-side" style={{ flex: 1, minWidth: 320, padding: '0 32px', animation: 'slideInLeft 1.4s' }}>
            <h1 style={{ fontSize: 36, color: '#2563eb', marginBottom: 16, fontWeight: 800, letterSpacing: '-1px' }}>What Makes Ventrai Special</h1>
            <p style={{ fontSize: 18, color: '#222', marginBottom: 8 }}>
              💬 <strong>Direct Connections:</strong> <span className="feature-highlight" style={{ background: '#e0e7ff', borderRadius: 8, padding: '2px 8px', transition: 'background 0.3s' }}>Chat directly with mentors who share your interests.</span>
            </p>
            <p style={{ fontSize: 18, color: '#222', marginBottom: 8 }}>
              🎯 <strong>Personalized Learning:</strong> <span className="feature-highlight" style={{ background: '#e0e7ff', borderRadius: 8, padding: '2px 8px', transition: 'background 0.3s' }}>Find mentors who match your goals, coding, creativity, leadership, or just finding your path.</span>
            </p>
            <p style={{ fontSize: 18, color: '#222', marginBottom: 8 }}>
              🔔 <strong>Smart Notifications:</strong> <span className="feature-highlight" style={{ background: '#e0e7ff', borderRadius: 8, padding: '2px 8px', transition: 'background 0.3s' }}>Stay updated about new mentors, conversations, and opportunities to grow.</span>
            </p>
            <p style={{ fontSize: 18, color: '#222', marginBottom: 8 }}>
              🌐 <strong>Community You Can Trust:</strong> <span className="feature-highlight" style={{ background: '#e0e7ff', borderRadius: 8, padding: '2px 8px', transition: 'background 0.3s' }}>Every mentor is reviewed to make sure our space stays positive and safe.</span>
            </p>
          </div>
          <div className="image-side" style={{ flex: 1, minWidth: 320, display: 'flex', justifyContent: 'center', alignItems: 'center', animation: 'slideInRight 1.4s' }}>
            <img
              src="https://raw.githubusercontent.com/DenzelDCB/k9g-EzD-WGg-8Pnc-x2g2-MWY-AG4UVn-y-7e-z-ep/Private-Images/community.png"
              alt="Community graphic"
              className="responsive-image"
              style={{ borderRadius: 18, boxShadow: '0 4px 24px rgba(16,185,129,0.12)', transition: 'transform 0.3s', cursor: 'pointer' }}
              onMouseOver={e => e.currentTarget.style.transform = 'scale(1.04)'}
              onMouseOut={e => e.currentTarget.style.transform = 'scale(1)'}
            />
          </div>
        </div>

        {/* TESTIMONIALS */}
        <div className="section" style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', marginBottom: 32 }}>
          <div className="image-side" style={{ flex: 1, minWidth: 320, display: 'flex', justifyContent: 'center', alignItems: 'center', animation: 'slideInLeft 1.6s' }}>
            <img
              src="https://raw.githubusercontent.com/DenzelDCB/k9g-EzD-WGg-8Pnc-x2g2-MWY-AG4UVn-y-7e-z-ep/Private-Images/people.png"
              alt="Mentor and mentee talking"
              className="responsive-image"
              style={{ borderRadius: 18, boxShadow: '0 4px 24px rgba(37,99,235,0.12)', transition: 'transform 0.3s', cursor: 'pointer' }}
              onMouseOver={e => e.currentTarget.style.transform = 'scale(1.04)'}
              onMouseOut={e => e.currentTarget.style.transform = 'scale(1)'}
            />
          </div>
          <div className="text-side" style={{ flex: 1, minWidth: 320, padding: '0 32px', animation: 'slideInRight 1.6s' }}>
            <h1 style={{ fontSize: 36, color: '#2563eb', marginBottom: 16, fontWeight: 800, letterSpacing: '-1px' }}>What People Are Saying</h1>
            <div style={{ fontSize: 18, color: '#222', marginBottom: 8, position: 'relative' }}>
              <span style={{ display: 'inline-block', animation: 'fadeInUp 1.2s' }}>
                “I found a mentor who helped me figure out what I want to do after school, and now I’m learning to code!”  
                <br /> <em style={{ color: '#2563eb', fontWeight: 600 }}> Jordan, 14 — Mentee</em>
              </span>
            </div>
            <div style={{ fontSize: 18, color: '#222', marginBottom: 8, position: 'relative' }}>
              <span style={{ display: 'inline-block', animation: 'fadeInUp 1.4s' }}>
                “Ventrai made it so easy to connect with someone who actually gets what I’m going through.”  
                <br /> <em style={{ color: '#2563eb', fontWeight: 600 }}> Maya, 16 — Mentee</em>
              </span>
            </div>
            <div style={{ fontSize: 18, color: '#222', marginBottom: 8, position: 'relative' }}>
              <span style={{ display: 'inline-block', animation: 'fadeInUp 1.6s' }}>
                “It’s the most positive space I’ve seen for young learners. You can learn, ask questions, and just be yourself.”  
                <br /> <em style={{ color: '#2563eb', fontWeight: 600 }}> Robert — Mentor</em>
              </span>
            </div>
          </div>
        </div>

        {/* OUR FUTURE */}
        <div className="section" style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
          <div className="text-side" style={{ flex: 1, minWidth: 320, padding: '0 32px', animation: 'slideInLeft 1.8s' }}>
            <h1 style={{ fontSize: 36, color: '#2563eb', marginBottom: 16, fontWeight: 800, letterSpacing: '-1px' }}>Our Vision for the Future</h1>
            <p style={{ fontSize: 18, color: '#222', marginBottom: 12 }}>
              Ventrai is growing fast, and so are our plans.  
              Soon, we’ll introduce mentor ratings, live sessions, and AI-assisted matching to help you find the best mentor faster.  
            </p>
            <p style={{ fontSize: 18, color: '#222', marginBottom: 12 }}>
              Our mission stays the same: create a space where every learner feels supported, every mentor feels valued, and every story matters.
            </p>
            <p style={{ fontWeight: 'bold', color: 'darkblue', fontSize: 20, marginTop: 16, animation: 'pulse 2s infinite' }}>
              Join us. Be part of something that’s changing how people learn, together.
            </p>
          </div>
          <div className="image-side" style={{ flex: 1, minWidth: 320, display: 'flex', justifyContent: 'center', alignItems: 'center', animation: 'slideInRight 1.8s' }}>
            <img
              src="https://raw.githubusercontent.com/DenzelDCB/k9g-EzD-WGg-8Pnc-x2g2-MWY-AG4UVn-y-7e-z-ep/Private-Images/future.png"
              alt="Future growth"
              className="responsive-image"
              style={{ borderRadius: 18, boxShadow: '0 4px 24px rgba(52,152,219,0.12)', transition: 'transform 0.3s', cursor: 'pointer' }}
              onMouseOver={e => e.currentTarget.style.transform = 'scale(1.04)'}
              onMouseOut={e => e.currentTarget.style.transform = 'scale(1)'}
            />
          </div>
        </div>
      </div>
      {/* Animations keyframes (can be moved to CSS) */}
      <style>{`
        @keyframes fadeIn { from { opacity: 0; transform: translateY(40px); } to { opacity: 1; transform: none; } }
        @keyframes slideInLeft { from { opacity: 0; transform: translateX(-60px); } to { opacity: 1; transform: none; } }
        @keyframes slideInRight { from { opacity: 0; transform: translateX(60px); } to { opacity: 1; transform: none; } }
        @keyframes fadeInUp { from { opacity: 0; transform: translateY(40px); } to { opacity: 1; transform: none; } }
        @keyframes pulse { 0% { transform: scale(1); } 50% { transform: scale(1.04); } 100% { transform: scale(1); } }
      `}</style>
    </div>
  );
}

export default Home;

